import { render, staticRenderFns } from "./InviteBlock.vue?vue&type=template&id=a0a74cb4&scoped=true&"
import script from "./InviteBlock.vue?vue&type=script&lang=js&"
export * from "./InviteBlock.vue?vue&type=script&lang=js&"
import style0 from "./InviteBlock.vue?vue&type=style&index=0&id=a0a74cb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0a74cb4",
  null
  
)

export default component.exports